// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.claims.RentalManagerUserClaimV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { UserClaimAddResponseV2WebDto, UserClaimAddV2RequestDto, UserClaimDeleteV2RequestDto } from '../..';

export const RentalManagerUserClaimV2WebApiHandler_add_Path = '/api/web/v2/users/claims/add';

/**
 * Add a new contact method
 */
export const RentalManagerUserClaimV2WebApiHandler_add = (postData: UserClaimAddV2RequestDto, client = getClient()) => {
  return httpFrontEndRequest<never, UserClaimAddV2RequestDto, UserClaimAddResponseV2WebDto>(
    {
      endpoint: RentalManagerUserClaimV2WebApiHandler_add_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserClaimV2WebApiHandler_delete_Path = '/api/web/v2/users/claims/delete';

/**
 * Delete a contact method
 */
export const RentalManagerUserClaimV2WebApiHandler_delete = (
  postData: UserClaimDeleteV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserClaimDeleteV2RequestDto, void>(
    {
      endpoint: RentalManagerUserClaimV2WebApiHandler_delete_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
